import React from "react";

import {PortfolioManagerResource} from "../../../utils/api";

export default (customerId, asset, onUpdate, active) => {
  const needToLoadDetails = !!active && !!customerId && asset.contractGuid && !asset._detailsLoaded;

  const [fetchState, setFetchState] = React.useState({loading: needToLoadDetails});

  React.useEffect(() => {
    if(needToLoadDetails){
      setFetchState({loading: true});

      PortfolioManagerResource.at(`customer/${customerId}/${asset.sub_category}/external-contracts/${asset.contractGuid}/`).get()
        .then((res) => {
          // "updated" needed only for checksum reset
          onUpdate({...asset, ...res, _detailsLoaded: true, updated: +new Date(), links: asset.linkedItems});
          setFetchState({
            loading: false,
            error: null,
          })
        })
        .catch((err) => {
          setFetchState({
            loading: false,
            error: err,
          })
        })
    }
  }, [needToLoadDetails]);

  return fetchState;
};